/** Calendar-specific datetime formatting. The local-input <-> ISO bridges now
 * live in `@/lib/datetime` (shared) and are re-exported here for convenience. */
export { toLocalInput, fromLocalInput } from '@/lib/datetime';

/** Human-friendly date + time range for display. */
export function formatEventWhen(starts: string, ends: string | null, allDay: boolean): string {
  const start = new Date(starts);
  const dateOpts: Intl.DateTimeFormatOptions = { weekday: 'short', month: 'short', day: 'numeric' };
  if (allDay) return `${start.toLocaleDateString(undefined, dateOpts)} · All day`;
  const timeOpts: Intl.DateTimeFormatOptions = { hour: 'numeric', minute: '2-digit' };
  const startStr = `${start.toLocaleDateString(undefined, dateOpts)}, ${start.toLocaleTimeString(undefined, timeOpts)}`;
  if (!ends) return startStr;
  const end = new Date(ends);
  const sameDay = start.toDateString() === end.toDateString();
  const endStr = sameDay
    ? end.toLocaleTimeString(undefined, timeOpts)
    : `${end.toLocaleDateString(undefined, dateOpts)}, ${end.toLocaleTimeString(undefined, timeOpts)}`;
  return `${startStr} – ${endStr}`;
}

/** Day bucket key (local) for grouping an agenda, e.g. "Mon, Jul 1". */
export function dayLabel(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}
